import React from 'react';
import DashboardList from './DashboardList';
import DashboardContext from '../DashboardContext';
import SubContext from '../../subs/SubContext';
import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 185;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: 'auto',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));

const DashboardDrawer = () => {
  const ctx = React.useContext(DashboardContext);
  const subCtx = React.useContext(SubContext);
  const classes = useStyles();

  if (ctx.dashboards.length === 0) {
    return null;
  }

  return (
    <div>
      {ctx.dashboards.length > 1 && subCtx.selectedSub && (
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <Toolbar />
          <div className={classes.drawerContainer}>
            <DashboardList />
          </div>
        </Drawer>
      )}
    </div>
  );
};

export default DashboardDrawer;
